import axios from 'axios';
import { PUBLISHING_SERVICE_URL } from '~/config';
import { withVersionHeaders } from '../utilities/axiosUtilities';
export function uploadFileToRLM(file, objectId, onUploadProgress) {
  const config = {
    ...withVersionHeaders(),
    onUploadProgress: function (progressEvent) {
      if (!onUploadProgress) {
        return;
      }
      const percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
      onUploadProgress(percentCompleted);
    }
  };
  const data = new FormData();
  data.append('fileBody', file);
  return axios.post(`${PUBLISHING_SERVICE_URL}/publishing/pricing-configuration-files/${objectId}`, data, config).then(response => {
    var _response$data$id;
    return (_response$data$id = response === null || response === void 0 ? void 0 : response.data.id) !== null && _response$data$id !== void 0 ? _response$data$id : null;
  }).catch(error => {
    console.error('File upload to RLM failed', error);
    return null;
  });
}